// extracted by mini-css-extract-plugin
export default {"container":"CommentsBoard_container__63OnH","card":"CommentsBoard_card__KW1kM","card-on":"CommentsBoard_card-on__YRAz+"};